<template>
  <div id="form" :style="`--data-themecolor:white`">
    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>
    <div class="row no-margins" v-if="!success">
      <div class="col s12  no-padding">
        <span
          class="chip"
          v-html="
            `<i class='material-icons-outlined left'>person</i>${user.first_name} ${user.last_name}`
          "
        ></span>
        <span
          class="chip"
          v-html="
            `<i class='material-icons-outlined left'>mail</i>${user.email}`
          "
        ></span>
      </div>
      <!--    <div class="input-field col s12 ">
          <div class="telephone label">Contact Number</div>
         <input type="tel"  v-model="user.telephone"  name="telephone" id="telephone">
       </div> -->
      <div class="col s12  no-padding">
        <div class="label">Type of Issue</div>
        <div class="description">
          General type of problem you're expiriencing
        </div>
        <div class="radio-group">
          <p>
            <label>
              <input
                v-model="form.issues"
                value="Completing Assessments"
                name="typeOf"
                type="checkbox"
              />
              <span>Completing Assessments</span>
            </label>
          </p>
          <p>
            <label>
              <input
                v-model="form.issues"
                value="App navigation"
                name="typeOf"
                type="checkbox"
              />
              <span>App navigation</span>
            </label>
          </p>
          <p>
            <label>
              <input
                v-model="form.issues"
                value="Saving and updating"
                name="typeOf"
                type="checkbox"
              />
              <span>Saving and updating</span>
            </label>
          </p>
          <p>
            <label>
              <input
                v-model="form.issues"
                value="other"
                name="typeOf"
                type="checkbox"
              />
              <span
                >Other -
                <span style="font-size: 12px;">list details below</span></span
              >
            </label>
          </p>
        </div>
      </div>
      <div class="col s12 input-field no-padding no-margin all">
        <div class="message label">Enter Message</div>
        <textarea
          class="materialize-textarea"
          :class="form.message !== '' ? 'valid' : 'invalid'"
          name="message"
          id="message"
          v-model="form.message"
          style="min-height:120px;"
        ></textarea>
        <div class="clear"></div>
        <span
          class="helper-text"
          data-error="A message is required"
          :data-success="`Vaild `"
          >Field cannot be empty</span
        >
      </div>
      <div class="col s12">
        <button
          @click="$_submit()"
          :disabled="form.message === ''"
          class="btn btn-rounded indigo accent-2 s12 col waves-effect"
        >
          Send Message
        </button>
      </div>
    </div>
    <div class="success" v-else>
      <div class="success-container">
        <i class="material-icons-outlined">check_circle</i>
      </div>
      <div class="success-message">
        Thank you for contacting Support. We will look into your request and get
        back to you within 48 hours.
      </div>

      <div class="success-actions">
        <button
          @click="$_returnToNav()"
          class="btn btn-rounded indigo accent-2 waves-effect modal-close"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import M from "materialize-css";
import axios from "axios";
const contentService = {};
export default {
  name: "contactForm",
  data() {
    return {
      success: false,
      loading: false,
      // eslint-disable-line
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        message: "",
        issues: [],
      },
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.User.user,
    }),
    toSubmit: {
      get() {
        return {
          your_name: this.user.first_name + " " + this.user.last_name,
          your_email: this.user.email,
          your_issues: `${this.form.issues.map((x) => {
            return ` ${x}`;
          })}`,
          your_message: this.form.message,
        };
      },
    },
    validate: {
      get() {
        return true;
      },
    },
  },
  methods: {
    isEmailValid: function() {
      return this.form.email === ""
        ? ""
        : this.reg.test(this.form.email)
        ? true
        : false;
    },
    $_returnToNav() {
      this.$emit("back", "nav");
    },
    $_submit() {
      this.loading = true;
      let formData = new FormData();
      Object.keys(this.toSubmit).forEach((x) => {
        formData.append(x, this.toSubmit[x]);
      });
      let url = `https://sldb.lc/users/support`;
      axios
        .post(url, this.toSubmit)
        .then(() => {
          this.success = true;
          this.loading = false;
          M.toast({ html: `Got it We'll talk soon :)` });
          this.form = {};
        })
        .catch((err) => {
          this.loading = false;
          M.toast({ html: `Opps something went wrong please try again later` });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
#form {
  padding: 20px;
  height: calc(100% - 48px);
  left: 0;
  right: 0;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  overflow-y: scroll;
  .form-title {
    font-size: 21px;
    line-height: 39px;
    margin-left: 8px;
    float: left;
  }
  .radio-group {
    p {
      margin: 8px 0px;
    }
  }

  .label {
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 0.4px;
    margin: 10px 0px 6px;
  }
  textarea {
    font-size: 14px;
  }
  .success-container {
    text-align: center;
    padding: 24px 0 10px 0;
    i {
      font-size: 106px;
      text-align: center;
      color: #109d59;
    }
    .success-message {
      text-align: center;
      font-size: 14px;
      padding: 0 10%;
    }
  }
}
.success-actions {
  padding: 12px;
  text-align: center;
  button {
    min-width: 150px;
  }
}
.progress {
  top: -7px;
  left: 0;
  position: absolute;
}
</style>
